import { formatDate, getDateByTimeZone } from "@/lib/date";

import BaseModel from "./base-model";

export const COMMENT_MENU_TYPE_LABEL = {
  GENERAL: "일반",
  DELAYED: "배송지연",
  CS: "CS",
  SENT_BACK: "반송완료",
  LOST_DAMAGED: "분실파손",
};

export const COMMENT_WRITER_SIDE = {
  ADMIN: "ADMIN",
  CORP: "CORP",
};

export default class DeliveryComment extends BaseModel {
  getCommentId() {
    return this.commentId || this.id;
  }

  getContent() {
    return this.content || this.text || this.comment || "";
  }

  getWriterName() {
    return this.writerName || "";
  }

  getWriterSide() {
    return this.writerSide || "";
  }

  renderWriterSide() {
    switch (this.getWriterSide()) {
      case COMMENT_WRITER_SIDE.ADMIN:
        return "관제";
      case COMMENT_WRITER_SIDE.CORP:
        return "파트너웹";
      default:
        return "";
    }
  }

  getMenuType() {
    const raw = this.menuType || "";

    return COMMENT_MENU_TYPE_LABEL[raw] || raw || "CS";
  }

  isCorpWriter(currentWriterName) {
    return (
      Boolean(currentWriterName) && this.getWriterName() === currentWriterName
    );
  }

  isAdminWriter() {
    return this.getWriterSide() === COMMENT_WRITER_SIDE.ADMIN;
  }

  getIsConfirmed() {
    return this.isConfirmed === true;
  }

  canConfirm() {
    return !this.getIsConfirmed() && this.isAdminWriter();
  }

  canMutate(currentWriterName) {
    return this.isCorpWriter(currentWriterName) && !this.getIsConfirmed();
  }

  getConfirmedByName() {
    return this.confirmedByName || this.confirmerName || this.confirmedBy || "";
  }

  renderCreatedAt() {
    if (!this.createdAt) {
      return "";
    }

    return formatDate(getDateByTimeZone(this.createdAt), "yyyy-MM-dd HH:mm");
  }

  renderConfirmedAt() {
    const value = this.confirmedAt || this.confirmedDate;

    if (!value) {
      return "";
    }

    return formatDate(getDateByTimeZone(value), "yyyy-MM-dd HH:mm");
  }
}
